import { request } from './Request';
import { routes } from '../constants/constant.route';
import Storage from "./Storage";

const { LOGIN, FORGOT_PASSWORD, LOGOUT } = routes.AUTH;

const API_URL = process.env.VITE_APP_API_URL;

export default class AuthService {

  static isAuthenticated() {
    let tokenDetail = Storage.getTokenDetail();
    if (tokenDetail && tokenDetail.accessToken) {
      return true;
    }
    return false;

  }

  static login(loginData) {
    const headers = {
      'content-type': 'application/x-www-form-urlencoded'
    };
    loginData = { ...loginData, grant_type: 'password' };
    return request('POST', `${API_URL}${LOGIN}`, null, loginData, headers);
  }

  static forgotPassword(body) {
    return request('POST', `${API_URL}${FORGOT_PASSWORD}`, null, body, null);
  }

  static logoutFromAllDevice() {
    return request('GET', `${API_URL}${LOGOUT}`, null, null, null);
  }

  static inviteSendOtp(body) {
    const headers = {
      'content-type': 'application/x-www-form-urlencoded'
    };
    return request('POST', `${API_URL}${routes.AUTH.SEND_OTP}`, null, body, headers);
  }

  static verifyOtp(obj) {
    return request('POST', `${API_URL}${routes.NEW_FLEET.VERIFY_OTP}`, null, obj, null);
  }

  static logout() {
    Storage.removeKeepMeLoggedInCookie();
    Storage.removeTokenDetail();
    Storage.removeUserDetail();
    Storage.removePlaceOrderCartItems();
    Storage.removeAddCustomerData();
    Storage.removePlaceOrderRedeemItems();
    // this.closeLogoutModal();
    // this.setState({ redirectToLoginPage: true });
  }
}